import { render, staticRenderFns } from "./headerTemplate.vue?vue&type=template&id=6774bd50&scoped=true&"
import script from "./headerTemplate.vue?vue&type=script&lang=js&"
export * from "./headerTemplate.vue?vue&type=script&lang=js&"
import style0 from "./headerTemplate.vue?vue&type=style&index=0&id=6774bd50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6774bd50",
  null
  
)

export default component.exports